import { reactive } from 'vue';

// state encapsulated and managed by the composable
const globalNonpersistedState = reactive({
    showLoadingModal: false,
    showSsoModalOnLogin: false,
});

const showSsoOnLoginModal = (newValue, showAppLoadingModal = false) => {
    if (newValue !== undefined) {
        globalNonpersistedState.showSsoModalOnLogin = newValue;
    }
    if (showAppLoadingModal !== undefined) {
        globalNonpersistedState.showLoadingModal = showAppLoadingModal;
    }

    return { globalNonpersistedState };
};

export default showSsoOnLoginModal;
